import { render, staticRenderFns } from "./TronTransactions.vue?vue&type=template&id=30fff045"
import script from "./TronTransactions.vue?vue&type=script&lang=js"
export * from "./TronTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports